import Black from '@/assets/forsport/fonts/Roboto-Black.ttf';
import BlackItalic from '@/assets/forsport/fonts/Roboto-BlackItalic.ttf';
import Bold from '@/assets/forsport/fonts/Roboto-Bold.ttf';
import BoldItalic from '@/assets/forsport/fonts/Roboto-BoldItalic.ttf';
import ExtraLight from '@/assets/forsport/fonts/Roboto-Thin.ttf';
import ExtraLightItalic from '@/assets/forsport/fonts/Roboto-ThinItalic.ttf';
import Light from '@/assets/forsport/fonts/Roboto-Light.ttf';
import LightItalic from '@/assets/forsport/fonts/Roboto-LightItalic.ttf';
import Regular from '@/assets/forsport/fonts/Roboto-Regular.ttf';
import Italic from '@/assets/forsport/fonts/Roboto-Italic.ttf';
import SemiBold from '@/assets/forsport/fonts/Roboto-Medium.ttf';
import SemiBoldItalic from '@/assets/forsport/fonts/Roboto-MediumItalic.ttf';

import KHInterferenceLight from '@/assets/forsport/fonts/KHInterference-Light.otf';
import KHInterferenceBold from '@/assets/forsport/fonts/KHInterference-Bold.otf';
import KHInterferenceRegular from '@/assets/forsport/fonts/KHInterference-Regular.otf';
import InterRegular from '@/assets/forsport/fonts/Inter-Regular.ttf';

export const fontFace = `
  @font-face {
    font-family: 'roboto';
    font-style: normal;
    font-weight: 100;
    font-display: swap;
    src: url('${ExtraLight}') format('opentype');
  }
  @font-face {
    font-family: 'roboto';
    font-style: italic;
    font-weight: 100;
    font-display: swap;
    src: url('${ExtraLightItalic}') format('opentype');
  }

  @font-face {
    font-family: 'roboto';
    font-style: normal;
    font-weight: 300;
    font-display: swap;
    src: url('${Light}') format('opentype');
  }
  @font-face {
    font-family: 'roboto';
    font-style: italic;
    font-weight: 300;
    font-display: swap;
    src: url('${LightItalic}') format('opentype');
  }

  @font-face {
    font-family: 'roboto';
    font-style: normal;
    font-weight: 400;
    font-display: swap;
    src: url('${Regular}') format('opentype');
  }
  @font-face {
    font-family: 'roboto';
    font-style: italic;
    font-weight: 400;
    font-display: swap;
    src: url('${Italic}') format('opentype');
  }

  @font-face {
    font-family: 'roboto';
    font-style: normal;
    font-weight: 500;
    font-display: swap;
    src: url('${SemiBold}') format('opentype');
  }
  @font-face {
    font-family: 'roboto';
    font-style: italic;
    font-weight: 500;
    font-display: swap;
    src: url('${SemiBoldItalic}') format('opentype');
  }

  @font-face {
    font-family: 'roboto';
    font-style: normal;
    font-weight: 700;
    font-display: swap;
    src: url('${Bold}') format('opentype');
  }
  @font-face {
    font-family: 'roboto';
    font-style: italic;
    font-weight: 700;
    font-display: swap;
    src: url('${BoldItalic}') format('opentype');
  }

  @font-face {
    font-family: 'roboto';
    font-style: normal;
    font-weight: 900;
    font-display: swap;
    src: url('${Black}') format('opentype');
  }
  @font-face {
    font-family: 'roboto';
    font-style: italic;
    font-weight: 900;
    font-display: swap;
    src: url('${BlackItalic}') format('opentype');
  }

  @font-face {
    font-family: 'KHInterference';
    font-style: normal;
    font-weight: 100;
    font-display: swap;
    src: url('${KHInterferenceLight}') format('opentype');
  }
  @font-face {
    font-family: 'KHInterference';
    font-style: normal;
    font-weight: 400;
    font-display: swap;
    src: url('${KHInterferenceRegular}') format('opentype');
  }
  @font-face {
    font-family: 'KHInterference';
    font-style: normal;
    font-weight: 700;
    font-display: swap;
    src: url('${KHInterferenceBold}') format('opentype');
  }
  @font-face {
    font-family: 'Inter';
    font-style: normal;
    font-weight: 400;
    font-display: swap;
    src: url('${InterRegular}') format('opentype');
  }
`;
